"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

exports.__esModule = true;

var React = __importStar(require("react"));

require("./card-header.scss");

var nama_icon_1 = require("../nama-icon");

var CardHeader = function CardHeader(_a) {
  var label = _a.label,
      iconName = _a.iconName,
      iconColor = _a.iconColor;
  return React.createElement("div", {
    className: "card-header"
  }, React.createElement(nama_icon_1.NamaIcon, {
    icon: iconName,
    className: "fill-" + iconColor
  }), React.createElement("h1", null, label));
};

exports.CardHeader = CardHeader;
CardHeader.defaultProps = {
  iconColor: "grey-800"
};